import { useCallback, useEffect, useMemo, useState } from 'react';
import { PlayerLayout } from '@embed/components/Player3/store/types';
import { openReasonPriority, VideoPlayerOpenReason, } from '@embed/components/VideoPlayer/types';
import { PostMessageSentinelEnum } from '@src/embeds/utils/postMessageWrapper';
import { GLOBAL_PLAYERS_STATE_SYNC, } from './usePlayerStateDispatcher';
export const usePlayerState = (appContext, params) => {
    var _a;
    const [playersStateSync, setPlayersStateSync] = useState(typeof window !== undefined && ((_a = window._fwn) === null || _a === void 0 ? void 0 : _a.playersStateSync)
        ? window._fwn.playersStateSync
        : {});
    useEffect(() => {
        const listener = (event) => {
            var _a;
            if (((_a = event.data) === null || _a === void 0 ? void 0 : _a.sentinel) === PostMessageSentinelEnum.INTERNAL) {
                const { action, state } = event.data;
                if (action !== GLOBAL_PLAYERS_STATE_SYNC) {
                    return;
                }
                setPlayersStateSync(state);
            }
        };
        try {
            window.parent.addEventListener('message', listener);
            return () => {
                window.parent.removeEventListener('message', listener);
            };
        }
        catch (e) {
            window.addEventListener('message', listener);
            return () => {
                window.removeEventListener('message', listener);
            };
        }
    }, [params.app_id, params.channel, params.playlist]);
    const videoPlayerState = useMemo(() => {
        for (const widgetId of Object.keys(playersStateSync)) {
            const player = playersStateSync[widgetId];
            if (player.layout === PlayerLayout.MINIMIZED ||
                player.layout === PlayerLayout.FULLSCREEN) {
                return player;
            }
        }
        return null;
    }, [playersStateSync]);
    const isOpened = params.widget_id && playersStateSync[params.widget_id]
        ? playersStateSync[params.widget_id].openReason !==
            VideoPlayerOpenReason.NOT_OPENED
        : false;
    const canClaimPlayer = useCallback((reason) => {
        return (!videoPlayerState ||
            videoPlayerState.widget_id === params.widget_id ||
            openReasonPriority[videoPlayerState.openReason] <=
                openReasonPriority[reason]);
    }, [videoPlayerState]);
    const isPlayingCurrentContent = useMemo(() => {
        if (!videoPlayerState) {
            return false;
        }
        return !!((params.playlist && params.playlist === videoPlayerState.playlist) ||
            ((appContext === null || appContext === void 0 ? void 0 : appContext.username) &&
                !params.playlist &&
                !videoPlayerState.playlist &&
                videoPlayerState.channel === (appContext === null || appContext === void 0 ? void 0 : appContext.username)) ||
            (params.app_id && params.app_id === videoPlayerState.app_id));
    }, [videoPlayerState]);
    const currentPlayerId = (videoPlayerState === null || videoPlayerState === void 0 ? void 0 : videoPlayerState.widget_id) || null;
    const currentPlayerLayout = (videoPlayerState === null || videoPlayerState === void 0 ? void 0 : videoPlayerState.layout) || null;
    const currentPlayerVideoId = (videoPlayerState === null || videoPlayerState === void 0 ? void 0 : videoPlayerState.videoId) || null;
    return useMemo(() => {
        return {
            canClaimPlayer,
            isOpened,
            isPlayingCurrentContent,
            currentPlayerId,
            currentPlayerLayout,
            currentPlayerVideoId,
        };
    }, [
        canClaimPlayer,
        isOpened,
        isPlayingCurrentContent,
        currentPlayerId,
        currentPlayerLayout,
        currentPlayerVideoId,
    ]);
};
